// Admin landing. Three tiles for the only three admin actions: deploy, presale, contracts.

import React from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { useUnifiedWallet } from '../contexts/UnifiedWalletContext';
import floobizMark from '../assets/floobiz-mark.jpg';
import './Home.css';

const SITE_NAME = process.env.REACT_APP_SITE_NAME || 'Floobiz';

function Home() {
  const { user } = useUser();
  const { isConnected, currentWallet, connectWallet, formatAddress } = useUnifiedWallet();

  return (
    <div className="home">
      <div className="home-hero">
        <img src={floobizMark} alt="" className="home-hero__logo" />
        <div>
          <h1>{SITE_NAME} admin</h1>
          <p>
            Welcome{user?.firstName ? `, ${user.firstName}` : ''}. Deploy your token, set sale
            parameters, and rotate the treasury — all from your own MetaMask.
          </p>
          <div className="home-wallet">
            {isConnected ? (
              <span>Connected: <code>{formatAddress(currentWallet?.account)}</code></span>
            ) : (
              <button className="home-btn" onClick={connectWallet}>Connect wallet</button>
            )}
          </div>
        </div>
      </div>

      <div className="home-tiles">
        <Link to="/deploy" className="home-tile">
          <h3>1. Deploy token</h3>
          <p>Sign and deploy the BEP-20 token from your wallet.</p>
        </Link>
        <Link to="/admin/presale" className="home-tile">
          <h3>2. Presale settings</h3>
          <p>Set price, sale allocation, and treasury on Sale.sol.</p>
        </Link>
        <Link to="/contracts" className="home-tile">
          <h3>3. Contracts</h3>
          <p>Audit log of every token you've deployed.</p>
        </Link>
        <Link to="/admin/transactions" className="home-tile">
          <h3>4. Transactions</h3>
          <p>Ledger of every verified buy — email, wallet, USDT in, tokens out.</p>
        </Link>
      </div>
    </div>
  );
}

export default Home;
